// src/pages/BasicInfoPage.js
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DataContext } from '../contexts/DataContext';
import ProductImageSection from '../components/ProductImageSection/ProductImageSection';
import ListSection from '../components/ListSection/ListSection';
import { formatDate } from '../utils/dateUtils';
import { getSafeText} from '../utils/valueResolver';

function BasicInfoPage() {
  const { t, i18n } = useTranslation(); 
  const { data } = useContext(DataContext);
  const lang = i18n.language;
  const product = data.ProductInfo;

  const listItems = [
    { label: t('basicInfo.purchaseDate'), value: formatDate(data.purchaseDate) },
    { label: t('basicInfo.serialNumber'), value: data.serialNumber },
    { 
      label: t('basicInfo.brand'),
      image: `/images/${product.logoImg}`,
      alt: getSafeText(product.brandName),
      width: 80,
      height: 20
    },
    { label: t('basicInfo.productName'), value: getSafeText(product.productName) },
    { 
      label: t('basicInfo.colorSize'), 
      value: `${getSafeText(product.color)} / ${getSafeText(product.size)}` 
    },
    {
      label: t('basicInfo.material'),
      value: getSafeText(product.material),
      isBorderless: true,
      description: getSafeText(product.materialNote),
    },
    { label: t('basicInfo.madeIn'), value: getSafeText(product.madeIn) },
    { label: t('basicInfo.distributor'), value: getSafeText(product.distributor) },
    {
      label: t('basicInfo.notes'),
      isBorderless: true,
      description: getSafeText(product.notes),
    },
  ];

  return (
    <>
      <div className="box-left">
        <ProductImageSection 
          src={`/images/basic_info/${product.productImg}`} 
          alt={getSafeText(product.productName)} 
        />
      </div>
      <div className="box-right">
        <ListSection items={listItems} />
  
  <a
  href="https://www.chaintope.com/"
  target="_blank"
  rel="noopener noreferrer"
  style={{ display: 'block', marginLeft: 'auto', width: 'fit-content' }}
>
 <img
  src="/images/logo_chaintope.svg"
  alt="chaintope Logo"
  style={{
    height: '50px',
    marginTop: '10px',
    display: 'block',
    borderRadius: '5px', // 角丸にする
    marginLeft: 'auto'}}
/>
</a>
      </div>
    </>
  );
}

export default BasicInfoPage;
